import { SelectBox } from "components/Select/Select";
import { InputHTMLAttributes, useContext, useEffect, useState } from "react";
import { trans, uuidv4 } from "utils/helpers";
import { getWarehouseDictionary } from "./api";
import "./style.scss";
import { InputLoad } from "components/InputLoading/inputLoading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "components/Button/Button";
import { ICON_TYPE, INVENTORYANDSALES_URL } from "utils/constants";
import { LayoutContext } from "layouts/DashboardLayout/context/LayoutContext";
import { ENDPOINTSINVENTORYANDSALES } from "utils/endpoints";
import { DictionarySelectBox } from "components/DictionaryTypeSelect/DictionaryTypeSelect";
import { CheckableButton } from "components/CheckableButton/CheckableButton";
import { Textbox } from "components/Textbox/Textbox";
import { ModalForm } from "components/ModalForm/ModalForm";
import { ItemsForPriceList } from "pages/InventoryAndSales/Sales/PriceList/components/ItemsForPriceList/ItemsForPriceList";
interface WarehouseDictionarySelectProp
  extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  name: string;
  value?: any;
  PriceListObj?: any;
  mode?: any;
  required?: boolean;
  Change?: (e) => void;
  setSelectedList?: (e) => void;
  selectedItemCallBack?: (e) => void;
  returnObj?: boolean;
}
export const WarehouseDictionarySelect = ({
  setSelectedList,
  selectedItemCallBack,
  label,
  name,
  value,
  PriceListObj,
  mode,
  required,
  Change,
  returnObj,
}: WarehouseDictionarySelectProp) => {
  const [
    optionsWarehouseDictionarySelect,
    setOptionsWarehouseDictionarySelect,
  ] = useState<any>({});
  const [errcode, setErrcode] = useState<any>();
  const [Warehouse, setWarehouse] = useState<any>();
  const [selectedItemList, setSelectedItemList] = useState<any>([]);
  const [selectedItem, setSelectedItem] = useState<any>();
  const [showTree, setShowTree] = useState<any>();
  const [treeType, setTreeType] = useState<any>();
  const [loading, setLoading] = useState(false);
  const [hasPriceListUnitOnly, setHasPriceListUnitOnly] = useState<any>(true);

  const WarehouseDictionarySelectApiAsync = async () => {
    try {
      const res = await getWarehouseDictionary();
      setOptionsWarehouseDictionarySelect({
        allWarehouses: { Description: "allWarehouses" },
        ...res.Data,
      });
      setSelectedItem({
        Id: "allWarehouses",
        Name: "allWarehouses",
      })
    } catch (error: any) {
      setErrcode(error.response.status);
    }
  };

  function addOption(e) {
    e.stopPropagation();
    e.preventDefault();
    let Id = Warehouse?.Id
      ? Warehouse.Id
      : Object.keys(optionsWarehouseDictionarySelect)[0];
      let WarehouseDetailId=Warehouse?.WarehouseDetailId??null
    if (Id =="allWarehouses" ) {
      setSelectedItemList({allWarehouses:{ Id: "allWarehouses", Name: "allWarehouses" , AllItems: true}});
      setSelectedItem({ Id: "allWarehouses", Name: "allWarehouses" ,AllItems: true});
    } else {
      console.log("ssssss" ,
        WarehouseDetailId,
        Id,
        selectedItemList
      )
       if (!Object.values(selectedItemList).find((item:any)=>item.Id==Id &&( !item.WarehouseDetailId || (item.WarehouseDetailId && item.WarehouseDetailId==WarehouseDetailId) ))) {
        //شرح شرط: اگر انباری با آیدی مشابه در لیست وجود داشته باشد و این انبار شامل انبار فرعی نباشد امکان اضافه کردن مجدد به لیست وجود ندارد پس انبار اصلی تکراری نخواهیم داشت. مگر اینکه انبار دارای انبار فرعی باشد و در آن مورد نیز تکراری نبودن انبار فرعی برسی میشود به قسمت شرط بعد از (||یا).
        setSelectedItemList({
          ...selectedItemList,
            [uuidv4()]:{   Id: Id,
              Name: optionsWarehouseDictionarySelect[Id].Description,
              WarehouseDetailId: Warehouse.WarehouseDetailId??null,
              AllItems: true,
              WarehouseDetail: Warehouse.WarehouseDetail??null}
        })

          setSelectedItem({
            Id: Id,
            Name: optionsWarehouseDictionarySelect[Id].Description,
            WarehouseDetailId: Warehouse.WarehouseDetailId??null,
            AllItems: true,
            WarehouseDetail: Warehouse.WarehouseDetail??null,
          });
      }
    }
  }

  async function deleteaOption(Id) {
    let data = JSON.parse(JSON.stringify(selectedItemList))
    delete data[Id] 
    setSelectedItemList(data);

    
    if (Id == selectedItem.Id) {
      setSelectedItem(Object.values(selectedItemList)[0]);
    }
  }
  function SelectItemCode(e ,Id ) {
    setTreeType({type:e , Id : Id});
    setShowTree(true);
  }



  const itemCodeHandeler = (obj,hasPrice) => {
    setLoading(true);
    setSelectedItemList((prev)=>{return{
      ...prev,
      [treeType.Id]: {
        ...prev[treeType.Id],
        [treeType.type]: obj.Code,
        HasPriceListUnitOnly: hasPrice ? true : false,

      },
    }});


    setShowTree(false);
  };
  useEffect(() => {
    selectedItemCallBack && selectedItemCallBack(selectedItem);
  }, [selectedItem]);

  useEffect(() => {
    if (loading) {
      setLoading(false);
    }
  }, [loading]);
  useEffect(() => {
    WarehouseDictionarySelectApiAsync();
  }, []);

  useEffect(() => {
    if(returnObj){
      setSelectedList && setSelectedList(selectedItemList);
    }else{
      setSelectedList && setSelectedList(selectedItemList.map((item)=>item.Id));
    }
  }, [selectedItemList]);

  

  return (
    <>
      {showTree && (
        <ModalForm
          mode={mode}
          title="ItemTree"
          onHide={() => setShowTree(false)}
          show={showTree}
        >
          <ItemsForPriceList
            isWarehouseItem={!selectedItemList.allWarehouses}
            defualtHasPriceUnit={selectedItemList[treeType.Id].HasPriceListUnitOnly}
            warehouseId={selectedItem?.Id}
            priceListId={PriceListObj?.Id}
            onHide={() => {
              setShowTree(false);
            }}
            itemCodeHandeler={(e, mode, hasPriceUnit) => {
            itemCodeHandeler(e,hasPriceUnit);
            }}
          />
        </ModalForm>
      )}
      {label ? (
        <label className="WarehouseDictionarySelect__label">
          {trans(label)}
        </label>
      ) : null}
      {true ? (
        <>
          <div
            className="row align-items-center"
            style={{
              alignItems: "center",
              flexDirection: "row",
              width: "100%",
            }}
          >
            <div className="col-5">
              <SelectBox
                onChange={(e) => {
                  if (Object.keys(selectedItemList).length == 0) {
                    setSelectedItem({
                      Id: e.target.value,
                      Name: optionsWarehouseDictionarySelect[e.target.value]
                        .Description,
                    });
                  }
                  setWarehouse({
                    Id: e.target.value,
                    Name: optionsWarehouseDictionarySelect[e.target.value]
                      .Description,
                  });
                  e.target.value !=
                  (value
                    ? value
                    : Object.keys(optionsWarehouseDictionarySelect)[0])
                    ? Change && Change({ [name]: e.target.value })
                    : Change && Change({ [name]: null });
                }}
                required={required}
                mode={
                Object.keys(selectedItemList).find(item=>item=='allWarehouses')  ? "view" : mode
                }
                lable="Warehouses"
                selectType="select"
                value={value}
                options={Object.values(optionsWarehouseDictionarySelect).map(
                  (item: any) => {
                    return item.Description;
                  }
                )}
                val={Object.keys(optionsWarehouseDictionarySelect)}
                name={name}
              ></SelectBox>
            </div>
            {optionsWarehouseDictionarySelect[Warehouse?.Id]
              ?.WarehouseDetailsCount > 0 && (
              <div className="col-5 mt-3">
                <DictionarySelectBox
                  name="WarehouseDetail"
                  label="WarehouseDetail"
                  params={{ warehouseId: Warehouse?.Id }}
                  onChange={(e, obj) => {
                    setSelectedItem((prev) => {
                      return {
                        ...prev,
                        WarehouseDetailId: e,
                        WarehouseDetail: obj?.Name,
                      };
                    });
                    setWarehouse((prev) => {
                      return {
                        ...prev,
                        WarehouseDetailId: e,
                        WarehouseDetail: obj?.Name,
                      };
                    });
                  }}
                  baseUrl={INVENTORYANDSALES_URL}
                  endPoint={
                    ENDPOINTSINVENTORYANDSALES.Inventory.BaseInformationApi
                      .WarehouseDetail.dictionary
                  }
                  // value={
                  //   mode != "create" ? selectedObj?.WarehouseDetailId : null
                  // }
                  // resetForm={resetForm}
                  mode={mode}
                />
              </div>
            )}

            <div style={{ marginTop: "20px", width: "10%" }}>
              <Button
                Icon={true}
                disabled={selectedItemList[0]?.Id=="allWarehouses"}
                value={
                  <button
                    disabled={selectedItemList[0]?.Id=="allWarehouses"}
                    onClick={addOption}
                    className={`checkButton ${
                      selectedItemList[0]?.Id=="allWarehouses" &&
                      "btn btn-primary disabled"
                    }`}
                  >
                    {" "}
                    <FontAwesomeIcon icon={[ICON_TYPE, "check"]} size="2x" />
                  </button>
                }
                btnType="submit"
              />
            </div>
          </div>
          <div className="group-person__selected-options-wrWarehouseer pe-4 mt-2 row gy-1">
            {Object.keys(selectedItemList).map((item, index) => (
              <div className="row">
                <div className="col-12 col-md-6 row">
                  <div
                    style={{ width: "auto" }}
                    className={`col-5 group-person__selected-option mt-4  p-0 px-3 ms-1 form-control-custom ${
                      item == selectedItem.Id &&
                      "group-person__selected-options-wrWarehouseer-active"
                    }   `}
                    key={item + index}
                  >
                    <div
                      style={{ cursor: "pointer" }}
                      className="d-flex align-items-center h-100 pe-1 ps-2"
                    >
                      {trans(selectedItemList[item].Name) +
                        (selectedItemList[item].WarehouseDetail
                          ? " - " + selectedItemList[item].WarehouseDetail
                          : "")}
                    </div>
                    <div
                      className="group-person__delete-selected-option"
                      data-key={item}
                      onClick={() => {
                        deleteaOption(item);
                      }}
                    >
                      <FontAwesomeIcon icon={[ICON_TYPE, "times"]} />
                    </div>
                  </div>
                  <div
                    className="col-7  row mb-3  "
                    style={{ marginTop: "1.4rem" }}
                  >
                    <CheckableButton
                      onchange={(e) => {
                        setSelectedItemList({
                          ...selectedItemList,
                          [item]: {
                            ...selectedItemList[item],
                            AllItems: e,
                            HasPriceListUnitOnly: true,
                          },
                        });
                      }}
                      type="checkradio"
                      labelText={trans("AllItems")}
                      labelFalseText={trans("limitedItems")}
                      defaultChecked={true}
                      checked={true}
                      inputName={"itemCode" + item}
                      mode={mode}
                    />
                  </div>
                </div>
                <div className="col-6 row">
                      {!selectedItemList[item].AllItems && (
                        <>
                          <div
                            className="col-md-6 "
                            style={{
                              display: "flex",
                              alignItems: "center",
                              flexDirection: "row",
                            }}
                          >
                            <Textbox
 
                              onChange={(e) => {
                                setSelectedItemList({
                                  ...selectedItemList,
                                  [item]: {
                                    ... selectedItemList[item],
                                    From: e.target.value,
                                  },
                                });
                              }}
                              placeholder={trans('itemCode')}
                              textboxName={"from"}
                              textboxType="text"
                              labelText={"from"}
                              mode={mode}
                              defaultValue={
                                selectedItemList[item]?.From
                              }
                            />
                            <div style={{ marginTop: "4px", width: "10%" }}>
                              <Button
                                Icon={true}
                                value={
                                  <button
                                    onClick={(e) => SelectItemCode("From"  , item)}
                                    type="button"
                                    className="checkButton"
                                  >
                                    {" "}
                                    <FontAwesomeIcon
                                      icon={[ICON_TYPE, "diagram-project"]}
                                      size="1x"
                                    />
                                  </button>
                                }
                                btnType="primary"
                                onClick={(e) => SelectItemCode("From"  , item)}
                              />
                            </div>
                          </div>
                          <div
                            className="col-md-6"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              flexDirection: "row",
                            }}
                          >
                            <Textbox

                              onChange={(e) => {
                                setSelectedItemList({
                                  ...selectedItemList,
                                  [item]: {
                                    ... selectedItemList[item],
                                    To: e.target.value,
                                  },
                                });
                              }}
                              textboxName={"To"}
                              textboxType="text"
                              placeholder={trans('itemCode')}
                              labelText={"To"}
                              mode={mode}
                              defaultValue={
                                selectedItemList[item]?.To
                              }
                            />
                           
                            <div style={{ marginTop: "4px", width: "10%" }}>
                              <Button
                                Icon={true}
                                value={
                                  <button
                                    onClick={(e) => SelectItemCode("To"  , item)}
                                    type="button"
                                    className="checkButton"
                                  >
                                    {" "}
                                    <FontAwesomeIcon
                                      icon={[ICON_TYPE, "diagram-project"]}
                                      size="1x"
                                    />
                                  </button>
                                }
                                btnType="primary"
                                onClick={(e) => SelectItemCode("To"  , item)}
                              />
                            </div>
                          </div>
                          <div >
                            <CheckableButton
                                  defaultChecked={selectedItemList[item].HasPriceListUnitOnly}
                                  checked={selectedItemList[item].HasPriceListUnitOnly}
                                  defaultValue={selectedItemList[item].HasPriceListUnitOnly}
                                  onchange={(e) => {
                                    setSelectedItemList({...selectedItemList ,[item]:{... selectedItemList[item] , HasPriceListUnitOnly: e} })
                                   }}
                                  labelText={"hasPriceListUnitOnly"}
                                  inputName={"hasPriceUnit"}
                                  type="checkbox"
                                  mode={"edit"}
                                  />
                                  
                            </div>
                        </>
                      )}
                </div>



              </div>
            ))}
          </div>
        </>
      ) : (
        <InputLoad
          msg={errcode}
          required={required}
          labelText={label}
          onClick={WarehouseDictionarySelectApiAsync}
        />
      )}
      <div className="text-box__msg-wrWarehouseer"></div>
    </>
  );
};
